import { parseGeneratedZones } from 'manual/zoneGeneratorParser';
import { setSelectedMapLayer, setCompleteMapLayers, setAvailableLayers } from 'manual';
import { parseGeneratedZonesFromUAPI } from 'manual/generatedZonesParser';

export const processGeneratedZones = ({ dispatch, generatedZones, isMultiLayerEnabled }) => {
  let zones;

  if (isMultiLayerEnabled) {
    zones = parseGeneratedZonesFromUAPI(generatedZones.features);
  } else {
    const recommendation = generatedZones?.recommendation;
    zones = recommendation ? parseGeneratedZones(recommendation) : {};
  }
  
  dispatch(setSelectedMapLayer({ zones }));
  return Promise.resolve(zones);
};

export const processCompleteMapLayers = ({dispatch, fieldId, jobId, year, completeLayers = []}) => {
  const completeLayersFiltered = completeLayers.reduce((obj, current) => {
    obj[current.eventDate] = current.layerUuid;
    return obj;
  }, {});
  dispatch(setCompleteMapLayers(jobId, fieldId, year, completeLayersFiltered));
  return Promise.resolve(completeLayersFiltered);
};

export const processAvailableLayers = async ({ dispatch, availableLayers, fieldUuid }) => {
  dispatch(setAvailableLayers(fieldUuid, availableLayers));
  return availableLayers;
};
